// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.convert.RentalManagerUserPropertyConvertWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyConvertMultiToSingleFamilyResponseWebDto,
  UserPropertyConvertSingleFamilyToRoomForRentResponseWebDto,
} from '../..';

interface MultiToSingleFamilyParams {
  modelId: string;
  unit?: string;
}
interface SingleFamilyToRoomForRentParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily_Path =
  '/api/web/v1/users/properties/convert/multiToSingleFamily';

/**
 * Convert a multifamily property to a single family property
 */
export const RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily = (
  getParams: MultiToSingleFamilyParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<MultiToSingleFamilyParams, never, UserPropertyConvertMultiToSingleFamilyResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyConvertWebApiHandler_multiToSingleFamily_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent_Path =
  '/api/web/v1/users/properties/convert/singleFamilyToRoomForRent';

/**
 * Convert a single family property to a room for rent property
 */
export const RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent = (
  getParams: SingleFamilyToRoomForRentParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    SingleFamilyToRoomForRentParams,
    never,
    UserPropertyConvertSingleFamilyToRoomForRentResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
